import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl} from 'react-intl';
import { falseIfUndefined, emptyStringIfUndefined, getTokenExpirationTimeinMinutes } from 'utils/HelperFunctions';
import * as constants from 'constants/App';
import Spinner from 'components/Spinner';
import FormWrapper from 'components/FormWrapper';
import { Popover, Overlay } from 'react-bootstrap';
import './ARIUser.css';
import { jwtDecode } from 'jwt-decode';
import * as helperFunctions from 'utils/HelperFunctions';
import * as configuration from 'configuration';
import * as sharedActions from 'actions/App';
import ARIUserInvalidTokenView from '../components/ARIUserInvalidTokenView';
import SearchVendor from '../components/SearchVendor';
import * as actions from '../actions/ARIUser';
import queryString from 'query-string'
import { useLocation } from 'react-router-dom';

const ARIUser = (props) => {
    const location = useLocation();

    let params = queryString.parse(location.search);
    let token = params != null && params.token != '' ? params.token : '';
    let subject = undefined;

    if (token) {
        try {
            const jwtToken = jwtDecode(token);
            subject = jwtToken.sub;
        }
        catch (err) {
            token = '';
        }
    }

    React.useEffect(() => {
        if (token) {
            props.dispatch(actions.saveARIUserToken(token));
        }
    }, [props.dispatch, token]);

    if (!(subject && subject === 'ARIUSER') || (helperFunctions.getTokenExpirationTimeinMinutes(token) <= 0)) {
        return <ARIUserInvalidTokenView />;
    }

    return <div className="row ari-user container-fluid" id="ari-user">
        <div className="col-sm-12">
            <SearchVendor />
        </div>
    </div>;
}

// Which props do we want to inject, given the global state?
function select(state) {
    return {
    };
}

export default connect(select)(injectIntl(ARIUser));